import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../notes/notes.component';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent implements OnInit {
  isTask?:any
  constructor(public dialogRef: MatDialogRef<WarningPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: {task:any, confirmation: any}) {
    this.isTask = data?.task ? data?.task : false
  }

  ngOnInit(): void {
    console.log(this.isTask);

  }
  closeDialog(returndata: any) {
    this.dialogRef.close(returndata);
  }

}
